<div class="container main width-alignment" style="max-width: 100% !important;">
    <!-- <div *ngIf="filterByCategory.length==0" class="noData"> Data Not Available!! </div> -->
    
    <div class="container-fluid" style="padding: 0px !important;">
        <!-- Audit UI Revamp -->
        <!-- Card: header + search + table + pagination -->
        <div class="table-container">

            <!-- Card Header Row -->
            <div class="page-header">
                <div class="header-content">
                <h2 class="page-title">List of Audit Trails</h2>
                <div class="header-actions">

                    <!-- Search -->
                    <div class="search-wrapper">
                    <input type="text" class="search-input" placeholder="Search for Audits..." [(ngModel)]="term"
                        (ngModelChange)="applyFilters()" oninput="this.value = this.value.replace(/[^A-Za-z0-9 ]|^ /g,'')">
                    <img src="assets/img/search.svg" class="search-icon">
                    </div>
                </div>
                </div>
            </div>

            <!-- Search, Advanced Search & Table -->
            <ng-container>

            <div class="search-advanced-row">
            
                 <!-- Select Category as per product-->
                    <div class="dropdown custom-select-dropdown" *ngIf="(product != 'corporate' && product != 'content' && product != 'connect') && (roleId != 'GH')">
                        <button class="btn custom-dropdown-btn dropdown-toggle" data-bs-toggle="dropdown"> {{ selectedCategory || 'Select Category' }} <mat-icon>keyboard_arrow_down</mat-icon> </button>
                        <ul class="dropdown-menu custom-dropdown-menu">
                            <li *ngFor="let i of categoryList" (click)="getCategory(i); $event.preventDefault()">
                                <a class="dropdown-item" href="javascript:void(0)">{{ i.name }}</a>
                            </li>
                        </ul>
                    </div> 

                    <div class="dropdown custom-select-dropdown" *ngIf="product == 'lauditor' && roleId == 'GH'">
                        <button class="btn custom-dropdown-btn dropdown-toggle" data-bs-toggle="dropdown"> {{ selectedCategory || 'Select Category' }} <mat-icon>keyboard_arrow_down</mat-icon> </button>
                        <ul class="dropdown-menu custom-dropdown-menu">
                            <li *ngFor="let i of categoryList" (click)="getCategory(i); $event.preventDefault()">
                                <a class="dropdown-item" href="javascript:void(0)">{{ i.name }}</a>
                            </li>
                        </ul>
                    </div>

                    <div class="dropdown custom-select-dropdown" *ngIf="product == 'content'">
                        <button class="btn custom-dropdown-btn dropdown-toggle" data-bs-toggle="dropdown"> {{ selectedCategory || 'Select Category' }} <mat-icon>keyboard_arrow_down</mat-icon> </button>
                        <ul class="dropdown-menu custom-dropdown-menu">
                            <li *ngFor="let i of categoryContGH" (click)="getCategory(i); $event.preventDefault()">
                                <a class="dropdown-item" href="javascript:void(0)">{{ i.name }}</a>
                            </li>
                        </ul>
                    </div>

                    <div class="dropdown custom-select-dropdown" *ngIf="product == 'connect'">
                        <button class="btn custom-dropdown-btn dropdown-toggle" data-bs-toggle="dropdown"> {{ selectedCategory || 'Select Category' }} <mat-icon>keyboard_arrow_down</mat-icon> </button>
                        <ul class="dropdown-menu custom-dropdown-menu">
                            <li *ngFor="let i of categoryConnectGH" (click)="getCategory(i); $event.preventDefault()">
                                <a class="dropdown-item" href="javascript:void(0)">{{ i.name }}</a>
                            </li>
                        </ul>
                    </div>

                    <div class="dropdown custom-select-dropdown" *ngIf="product == 'corporate'">
                        <button class="btn custom-dropdown-btn dropdown-toggle" data-bs-toggle="dropdown"> {{ selectedCategory || 'Select Category' }} <mat-icon>keyboard_arrow_down</mat-icon> </button>
                        <ul class="dropdown-menu custom-dropdown-menu">
                            <li *ngFor="let i of categoryCorp" (click)="getCategory(i); $event.preventDefault()">
                                <a class="dropdown-item" href="javascript:void(0)">{{ i.name }}</a>
                            </li>
                        </ul>
                    </div>
                <!-- Select Category as per product-->

                <!-- Left Side - Search -->
                <!-- <div class="search-wrapper">
                    <input type="text" class="search-input" placeholder="Search for Audits..." [(ngModel)]="term"
                        (ngModelChange)="applyFilters()" oninput="this.value = this.value.replace(/[^A-Za-z0-9 ]|^ /g,'')">
                    <img src="assets/img/search.svg" class="search-icon">
                </div> -->
            
                
                <!-- Right Side - Advanced Toggle -->
                <div class="advanced-search-wrapper">
                    <span class="advlabel">Advanced Search</span>
            
                    <label class="switch">
                        <input type="checkbox"  [(ngModel)]="isAdvancedSearch" (change)="onAdvancedToggle()">
                        <span class="slider"></span>
                    </label>
                </div>
            
            </div>
            
            <!-- Advanced Section -->
            <div class="advanced-section" *ngIf="isAdvancedSearch">
                <div class="date-group">
            
                    <!-- FROM DATE -->
                    <div class="input-box">
                        <label class="field-label">From</label>
            
                        <div class="date-input-wrapper">
                            <input #fromDp="bsDatepicker" bsDatepicker [(bsValue)]="fromDate" [maxDate]="maxDate"
                                [bsConfig]="datePickerConfig" (bsValueChange)="onFromDateChange($event)" class="form-input dpc"
                                placeholder="Select" readonly (keydown)="$event.preventDefault()" (paste)="$event.preventDefault()" (keypress)="$event.preventDefault()"/>
            
                            <img src="assets/img/cal-icon.svg" class="calendar-icon" (click)="fromDp.show()" />
                        </div>
                    </div>
            
                    <!-- TO DATE -->
                    <div class="input-box">
                        <label class="field-label">To</label>
            
                        <div class="date-input-wrapper">
                            <input #toDp="bsDatepicker" bsDatepicker [(bsValue)]="toDate" [minDate]="fromDate" [maxDate]="maxDate"
                                [bsConfig]="datePickerConfig" (bsValueChange)="onToDateChange($event)" class="form-input dpc"
                                placeholder="Select" readonly (keydown)="$event.preventDefault()" (paste)="$event.preventDefault()" (keypress)="$event.preventDefault()"/>
            
                            <img src="assets/img/cal-icon.svg" class="calendar-icon" (click)="toDp.show()" />
                        </div>
                    </div>
            
                </div>
            </div>

            <div class="table-responsive-wrapper" *ngIf="filterByCategory.length > 0">
            <table class="head-table">
            <thead>
                <tr>
                <th>
                    <div class="th-content">
                    <span>Category</span>
                    <img src="assets/img/SORT.PNG" class="sort-icon" (click)="sortDocuments('name')" alt="Sort">
                    </div>
                </th>
                <th>
                    <div class="th-content">
                    <span>Date & Time</span>
                    <img src="assets/img/SORT.PNG" class="sort-icon" (click)="sortDocuments('timestamp')" alt="Sort">
                    </div>
                </th>
                <th>
                    <div class="th-content">
                    <span>Activity Logs</span>
                    <img src="assets/img/SORT.PNG" class="sort-icon" (click)="sortDocuments('message')" alt="Sort">
                    </div>
                </th>  
                <th></th>       
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let log of filterByCategory | paginate: { itemsPerPage: 10, currentPage: p }">
                    <td *ngIf="log.name=='AUTH'">AUTHENTICATION</td>
                    <td *ngIf="log.name === 'DEPARTMENTS' && product === 'corporate'">DEPARTMENTS</td>
                    <td *ngIf="log.name === 'GROUPS' && product !== 'corporate'">GROUPS</td>
                    <td *ngIf="log.name !== 'AUTH' && log.name !== 'DEPARTMENTS' && log.name !== 'GROUPS'">{{log.name}}</td>
                    <td style="width: 200px;">{{log.timestamp | date: 'MMM d, y | h:mm a'}}</td>
                    <td>{{log.message}}</td>
                </tr>
            </tbody>
            </table>
            </div>


            <!-- EMPTY STATE -->
            <div *ngIf="filterByCategory.length==0" class="empty-state-container">
                <img src="assets/img/e-matter.png" class="empty-state-icon" alt="No entries">
                <p class="empty-state-title">Data Not Available!</p>
                <p class="empty-state-subtitle">There are no Audit entries under this category.</p>
            </div>

            </ng-container>

            <!-- Pagination -->
            <div class="nav-buttons" *ngIf="filterByCategory.length > 0">
                <!-- <label class="pag-info">Showing <span>{{fromCount}}</span> to <span>{{toCount}}</span> of <span *ngIf="filterByCategory">{{filterByCategory.length}}</span> entries</label> -->
                <div class="pag-btns">
                    <button class="prev" (click)="prev()" [disabled]="p === 1">&lt;&lt; Prev</button>
                    <button class="next" (click)="next()" [disabled]="p === totalPages">Next &gt;&gt;</button>
                </div>
            </div>

        </div><!-- /table-container -->

    </div>
</div>

<ngx-spinner size="medium" type="ball-clip-rotate"></ngx-spinner>